import router                from '@/router';
import store                 from '@/store';
import {
    POLL_INTERVAL_HIDDEN_MS,
    STUDENT_DETAIL_POLL_INTERVAL_MS,
    STUDENT_STATUS_POLL_INTERVAL_MS,
} from '@/assets/js/common/app-config';
import { sanitizeHtml }      from '@/assets/js/common/sanitize';
import { useField, useForm } from 'vee-validate';
import { ref }               from "vue";
import { VDataTable }        from 'vuetify/labs/VDataTable'
import * as yup              from 'yup';
import StudentDataService    from './services/StudentDataService';

export default {

    name: 'Aluno',
    components: { VDataTable },

    data: () => ({
        cardText: 'Aguardando início da atividade avaliativa.',
        dialogClassPwd: false,
        dialogGroup: false,
        headersClassroom: [
            { title: 'Aluno (a)', key: 'nome', align: 'center', width: '100%' },
        ],
        headersClassrooms: [
            { title: 'Professor (a)', key: 'prof', align: 'center', width: '60%' },
            { title: 'Atividade Avaliativa', key: 'nome', align: 'center', sortable: false, width: '40%' },
        ],
        headersTests: [
            { title: 'Nome', key: 'nome', align: 'start', width: '60%' },
            { title: 'Questões', key: 'perguntas.length', align: 'center', width: '10%' },
            { title: 'Status', key: 'get_status_display', align: 'center', width: '20%' },
            { title: 'Criação', key: 'datetime', align: 'center', width: '10%' },
        ],
        interval: null,
        interval2: null,
        isFormDisabled: false,
        isFormValid: false,
        liderId: null,
        liderName: '',
        listClassrooms: [],
        listStudents: [],
        loadingClassrooms: true,
        loadingNM: true,
        loadingNI: true,
        loadingNE: true,
        loadingSaveAnswer: false,
        loadingSaveGroup: false,
        loadingSaveGroupAnswer: false,
        loadingStudents: true,
        loadingTests: true,
        meInGroup: false,
        notaEquipe: null,
        notaIndividual: null,
        notaMaxima: null,
        nAlts: null,
        nQuestoes: null,
        Questoes: [],
        selectedStudents: [store.state.userId],
        sortByData: [{ key: 'datetime', order: 'desc' }, { key: 'nome', order: 'asc' }],
        sortByName: [{ key: 'nome', order: 'asc' }],
        sortByProf: [{ key: 'prof', order: 'asc' }],
        provaId: null,
        provaNome: '',
        provaSenha: '',
        statusNomeProva: '',
        statusProva: '',
        statusPollingBusy: false,
        detailPollingBusy: false,
        statusTime: STUDENT_STATUS_POLL_INTERVAL_MS,
        detailTime: STUDENT_DETAIL_POLL_INTERVAL_MS,
        hiddenTime: POLL_INTERVAL_HIDDEN_MS,

        provaOK: false,
        questionIndex: 0,
        answers: [],
        savedIndividualAnswers: [],
        showErrorMessage: false,

        attempt: 0,
        group: [],
        groupAnswer: '',
        groupLeaderTestId: null,
        groupName: '',
        isRadioDisabled: [],
        requiredField: [v => !!v || 'O campo é obrigatório.'],
    }),

    setup() {
        const alert            = ref(false);
        const alertText        = ref('');
        const alertType        = ref(null);
        const loadingStartTest = ref(false);
        const sbColor          = ref('');
        const sbMessage        = ref('');
        const snackbar         = ref(false);
        const testId           = ref('');

        const validationSchema = yup.object().shape({
            senha: yup.string().required('Campo obrigatório.').min(4, 'A senha precisa de 4 caracteres.'),
        });
        
        const { handleSubmit, handleReset } = useForm({
            validationSchema,
        });

        const senha = useField('senha', validationSchema);

        const onSubmit = handleSubmit(async (values) => {
            loadingStartTest.value = true;
            await StudentDataService.enterClassroom({id: testId.value, senha: values.senha}).then(response => {
                router.push({ path: '/Aluno/Prova/'+testId.value });
            }).catch(error => {
                alertType.value = 'error';
                alertText.value = error.response.data.error;
                alert.value     = true;
                sbColor.value   = alertType.value;
                sbMessage.value = alertText.value;
                alert.value     = true;
                snackbar.value  = true;
            })
            loadingStartTest.value = false;
            handleReset();
        });

        return { alert, alertType, alertText, loadingStartTest, sbColor, sbMessage, snackbar, testId, senha, onSubmit, handleReset };
    },

    mounted() {
        if (typeof document !== 'undefined') {
            document.addEventListener('visibilitychange', this.handleVisibilityChange);
        }
        this.handlePageChange(this.currentParamsPage);
    },

    beforeUnmount() {
        this.stopPolling();
        if (typeof document !== 'undefined') {
            document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        }
    },

    computed: {
        currentParamsPage() {
            return this.$route.params;
        },
        currentQuestion() {
            return this.questoes[this.questionIndex] || {};
        },
        currentQuestionIndex() {
            return this.questionIndex;
        },
    },

    watch: {
        alert(new_val){
            if(new_val){
              setTimeout(()=>{this.alert=false}, 5000)
            }
        },  
        currentQuestionIndex(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.handleQuestionIndexChange();
            }
        },
        currentParamsPage(newVal, oldVal) {
            this.handlePageChange(newVal);
        },
    },

    methods: {

        sanitizeHtml,

        clearPollingTimer(timerName) {
            if (this[timerName]) {
                clearInterval(this[timerName]);
                this[timerName] = null;
            }
        },

        clearGroupLeaderCache(preserveGroupDraft = false) {
            this.groupLeaderTestId = null;
            this.liderId = null;
            this.liderName = '';
            this.group = [];
            if (!preserveGroupDraft) {
                this.groupName = '';
            }
        },

        getAdaptivePollInterval(baseInterval) {
            if (typeof document !== 'undefined' && document.hidden) {
                return Math.max(this.hiddenTime, baseInterval);
            }
            return baseInterval;
        },

        getGroupFormationPollInterval() {
            return Math.max(this.detailTime * 3, 20000);
        },

        handleVisibilityChange() {
            if (this.currentParamsPage.aPage === 'Prova') {
                this.handlePageChange(this.currentParamsPage);
            }
        },

        async handleQuestionIndexChange() {
            if (this.statusProva === '2') {
                this.syncIndividualQuestionState();
            }
            if (this.statusProva === '4' && this.provaId) {
                await this.syncGroupQuestionState(this.provaId);
            }
        },

        extractSavedAnswerWeights(answerGroup) {
            if (!answerGroup || !Array.isArray(answerGroup.answers)) {
                return null;
            }

            return answerGroup.answers.map((answer) => {
                const rawValue = answer?.answer;
                if (rawValue === null || rawValue === undefined || rawValue === '') {
                    return null;
                }

                const parsedValue = parseInt(rawValue, 10);
                return Number.isNaN(parsedValue) ? null : parsedValue;
            });
        },

        syncIndividualQuestionState() {
            const answersLength = Array.isArray(this.currentQuestion.answers) ? this.currentQuestion.answers.length : 0;
            const savedWeights = this.savedIndividualAnswers[this.questionIndex];

            this.showErrorMessage = false;

            if (Array.isArray(savedWeights) && savedWeights.length > 0) {
                this.answers = [...savedWeights];
                this.isFormDisabled = true;
            } else {
                this.answers = Array.from({ length: answersLength }, () => null);
                this.isFormDisabled = false;
            }

            if (this.$refs.formAnswer) {
                this.$refs.formAnswer.resetValidation();
            }
        },

        schedulePolling(timerName, busyFlagName, task, baseInterval) {
            this.clearPollingTimer(timerName);
            this[timerName] = setInterval(async () => {
                if (this[busyFlagName]) {
                    return;
                }

                this[busyFlagName] = true;
                try {
                    await task();
                } finally {
                    this[busyFlagName] = false;
                }
            }, this.getAdaptivePollInterval(baseInterval));
        },

        async syncStudentStatus() {
            const previousStatus = this.statusProva;
            const previousProvaId = this.provaId;
            const activeStatus = await this.getActiveTestStatus();

            if (activeStatus === 0) {
                this.stopPolling();
                this.clearGroupLeaderCache();
                this.sbColor   = 'success';
                this.sbMessage = 'Voce saiu da sala!';
                this.snackbar  = true;
                setTimeout(() => { router.push({ path: '/aProvas/Listar' }); }, 2500);
                return;
            }

            if (activeStatus !== null) {
                if (previousProvaId !== activeStatus.id) {
                    this.clearGroupLeaderCache();
                }

                this.provaId = activeStatus.id;

                if (previousStatus !== activeStatus.status || previousProvaId !== activeStatus.id) {
                    const provaId = await this.isTestActivated();

                    if (provaId !== null && provaId !== 0) {
                        await this.applyStudentStageState(provaId);
                        if (this.$route.path !== `/Aluno/Prova/${provaId}`) {
                            router.push({ path: '/Aluno/Prova/' + provaId });
                        }
                    }
                    return;
                }

                this.statusProva = activeStatus.status;
                this.statusNomeProva = activeStatus.get_status_display;
            }
        },

        startDetailPolling(task, baseInterval = this.detailTime) {
            this.schedulePolling(
                'interval2',
                'detailPollingBusy',
                task,
                baseInterval,
            );
        },

        startStatusPolling() {
            this.schedulePolling(
                'interval',
                'statusPollingBusy',
                async () => {
                    await this.syncStudentStatus();
                },
                this.statusTime,
            );
        },

        stopDetailPolling() {
            this.clearPollingTimer('interval2');
        },

        stopPolling() {
            this.clearPollingTimer('interval');
            this.clearPollingTimer('interval2');
        },

        async checkStudentAnswer(id) {
            try {
                const response = await StudentDataService.checkStudentAnswer(id);
                return response.data;
            } catch (error) {
                console.log(error);
            }
        },

        async checkGroupAnswer(id) {
            try {
                const response = await StudentDataService.checkGroupAnswer(id);
                return response.data;
            } catch(error) {
                console.log(error);
            }
        },

        createGroup() {
            if (this.selectedStudents.length === 0) {
                this.sbColor   = 'error';
                this.sbMessage = 'Selecione ao menos uma pessoa!';
                this.snackbar  = true;
            }
            else if (!this.selectedStudents.includes(store.state.userId)) {
                this.sbColor   = 'error';
                this.sbMessage = 'Você precisa estar no grupo!';
                this.snackbar  = true;
            }
            else {
                this.dialogGroup = true;
            }
        },

        closeDialogClassPwd() {
            this.handleReset();
            this.alert          = false;
            this.dialogClassPwd = false;
            this.snackbar       = false;
            this.testId         = '';
        },

        closeDialogGroup() {
            this.dialogGroup = false;
        },

        disableRadio(index) {
            this.isRadioDisabled[index] = true;
        },

        enableRadio() {
            for (let i = 0; i < this.nAlts; i++) {
                this.isRadioDisabled[i] = false;
            }
        },

        formatDate(dateString) {
            const date = new Date(dateString);
            // Then specify how you want your dates to be formatted
            return new Intl.DateTimeFormat('pt-BR', {timeZone: 'America/Sao_Paulo'}).format(date);
        },

        async getClassrooms() {
            await StudentDataService.listClassrooms(store.state.userId).then(response => {
                this.listClassrooms    = response.data;
                this.loadingClassrooms = false;
            }).catch(error => {
                console.log(error);
            })
        },

        getLabel(index) {
            return String.fromCharCode(65 + index); // Retorna as letras A, B, C, ...
        },

        async getLider(id) {
            try {
                const response = await StudentDataService.getLider(id);
                if (response.data) {
                    return response.data;
                }
                return null; // Retornar um valor padrão caso não haja líder.
            } catch (error) {
                console.log(error);
                return null;
            }
        },

        getStudents(id) {
            StudentDataService.listStudents(id).then(response => {
                if (response.data[0].meInGroup){
                    let lider = response.data[0].meInGroup;
                    const groupMembers = response.data.slice(2);
                    const liderData = groupMembers.find((item) => item.id === lider);
                    this.meInGroup = true;
                    this.groupLeaderTestId = id;
                    this.liderId = lider;
                    this.liderName = liderData ? liderData.nome : this.liderName;
                    this.groupName = response.data[1].groupName;
                    this.group     = groupMembers.map((item, index) => {
                        return item.id === lider ? item.nome + ' (líder)' : item.nome;
                    });
                    this.group.sort((a, b) => a.localeCompare(b));
                    return lider
                }
                else {
                    this.listStudents = response.data;
                    this.meInGroup    = false;
                    this.clearGroupLeaderCache(this.dialogGroup);
                }
            }).catch(error => {
                console.log(error);
            })
            this.loadingStudents  = false;
        },

        getValidationRules(nAnswers) {
            let total   = 0;
            let control = false;
            
            for (let i = 0; i < nAnswers; i++) {
                if (this.answers[i] === null || this.answers[i] === undefined || this.answers[i] === '') {
                    control = true;
                }
                else {
                    total += this.answers[i];
                }
            }

            if (!control && total != nAnswers) {
                this.showErrorMessage = true;
            } 
            else {
                this.showErrorMessage = false;
                control               = false;
            }
            
            return [
                (v) => v !== null && v !== undefined && v !== '' || 'O campo é obrigatório.',
                (v) => total === nAnswers || ''
            ];
        },

        getValidationRules2() {
            return [
                (v) => v !== null && v !== undefined && v !== '' || 'O campo é obrigatório.',
            ];
        },

        getWeights(nAnswers) {
            return Array.from({ length: nAnswers + 1 }, (_, i) => i);
        },

        async applyStudentStageState(provaId) {
            let response;

            this.stopDetailPolling();

            if (this.statusProva === '2') {
                this.cardText       = 'Atividade avaliativa individual concluida. Aguarde!';
                this.provaOK        = false;
                this.isFormDisabled = false;
                response            = await this.checkStudentAnswer(provaId);

                if (response > 0) {
                    if (response === this.nQuestoes) {
                        this.provaOK        = true;
                        this.isFormDisabled = true;
                    }
                    else if (this.questionIndex !== response) {
                        this.isFormDisabled = true;
                    }
                }

                this.syncIndividualQuestionState();
            }
            else if (this.statusProva === '3') {
                this.questionIndex = 0;
                this.provaOK       = false;
                await this.getStudents(provaId);
                this.startDetailPolling(async () => {
                    await this.getStudents(provaId);
                }, this.getGroupFormationPollInterval());
            }
            else if (this.statusProva === '4') {
                await this.syncGroupQuestionState(provaId);
            }
        },

        async ensureGroupLeaderLoaded(provaId) {
            if (this.groupLeaderTestId === provaId && this.liderId !== null) {
                return {
                    id: this.liderId,
                    nome: this.liderName,
                };
            }

            const lider = await this.getLider(provaId);

            if (!lider) {
                return null;
            }

            this.groupLeaderTestId = provaId;
            this.liderId = lider.id;
            this.liderName = lider.nome;
            return lider;
        },

        async syncGroupQuestionState(provaId) {
            let lider = await this.ensureGroupLeaderLoaded(provaId);
            let response;

            if (!lider) {
                return;
            }

            this.liderId   = lider.id;
            this.liderName = lider.nome;
            this.cardText  = 'Atividade avaliativa em equipe concluida. Aguarde!';
            this.provaOK   = false;

            response = await this.checkGroupAnswer(provaId);

            if (Object.keys(response).length === 0) {
                this.attempt        = 0;
                this.isFormDisabled = false;
                this.groupAnswer    = '';
                if (this.$refs.formAnswer) {
                    this.$refs.formAnswer.reset();
                }
                this.enableRadio();
                return;
            }

            const lastQuestionKey = 'question' + this.nQuestoes;
            if (response[lastQuestionKey] && response[lastQuestionKey].find(item => item === this.questoes[this.nQuestoes - 1].altTrue)) {
                this.provaOK = true;
                return;
            }

            const currentKey = 'question' + (this.questionIndex + 1);
            this.attempt        = 0;
            this.isFormDisabled = false;
            this.groupAnswer    = '';

            if (response[currentKey]) {
                this.enableRadio();
                for (let i = 0; i < response[currentKey].length; i++) {
                    if (response[currentKey][i] !== undefined) {
                        if (response[currentKey][i] === this.currentQuestion.altTrue) {
                            this.enableRadio();
                            this.isFormDisabled = true;
                        }
                        else {
                            this.disableRadio(response[currentKey][i] - 1);
                            this.attempt++;
                        }
                    }
                }
            }
            else {
                if (this.$refs.formAnswer) {
                    this.$refs.formAnswer.reset();
                }
                this.enableRadio();
            }
        },

        async handlePageChange(params) {

            try {

                this.stopPolling();

                this.dialogClassPwd = false;

                if (params.aPage !== 'Prova') {
                    return;
                }

                const provaId = await this.isTestActivated();

                if (provaId !== 0 && provaId !== null) {
                    await this.applyStudentStageState(provaId);
                    this.startStatusPolling();

                    if (this.$route.path !== `/Aluno/Prova/${provaId}`) {
                        router.push({ path: '/Aluno/Prova/' + provaId });
                    }
                    return;
                    /*

                    clearInterval(this.interval);
                    clearInterval(this.interval2);
                    
                    this.interval = setInterval(async () => { 
                        const data = await this.isTestActivated();
                        if (data === 0) {
                            clearInterval(this.interval);
                            this.sbColor        = 'success';
                            this.sbMessage      = 'Vocẽ saiu da sala!';
                            this.snackbar       = true;
                            setTimeout(()=>{router.push({ path: '/aProvas/Listar' })}, 2500)
                        }
                    }, this.time);                        
                    
                    if (this.statusProva === '2') {
                        
                        response      = await this.checkStudentAnswer(provaId);
                        this.cardText = 'Atividade avaliativa individual concluída. Aguarde!';

                        if (response > 0) {
                            if (response === this.nQuestoes) { this.provaOK = true; }
                            else if (this.questionIndex === response) { this.isFormDisabled = false; }
                            else { this.isFormDisabled = true; }
                        }
                    }
                    else if (this.statusProva === '3') { 
                        this.questionIndex = 0;
                        this.provaOK       = false; 
                        this.interval2     = setInterval(async () => {this.getStudents(provaId)}, this.time); 
                    }
                    else if (this.statusProva === '4') { 

                        let lider      = await this.getLider(this.provaId);
                        this.liderId   = lider.id;
                        this.liderName = lider.nome;

                        response                  = await this.checkGroupAnswer(provaId)
                        this.cardText             = 'Atividade avaliativa em equipe concluída. Aguarde!';
                        const currentQuestionUser = Object.keys(response).length;
                        const currentQuestionTest = (this.questionIndex + 1);

                        if (currentQuestionUser > 0) {

                            let key = 'question' + (this.nQuestoes);

                            if (response[key] && response[key].find(item => item === this.questoes[(this.nQuestoes-1)].altTrue)) {
                                this.provaOK = true;
                            }
                            else {

                                key                 = 'question' + (this.questionIndex+1);
                                this.attempt        = 0;
                                this.isFormDisabled = false; 

                                if (response[key]) {
                                    for (let i = 0; i < response[key].length; i++) {
                                        if (response[key][i] !== undefined) {
                                            if (response[key][i] === this.currentQuestion.altTrue) {
                                                this.enableRadio();
                                                this.isFormDisabled = true;
                                            } else {
                                                this.disableRadio(response[key][i]-1);
                                                this.attempt++;
                                            }
                                        }
                                    }
                                }
                                else {
                                    this.$refs.formAnswer.reset();
                                    this.enableRadio();
                                }
                            }
                        }
                    }

                    router.push({ path: '/Aluno/Prova/' + provaId });
                    */

                }
                else if (provaId === 0) { this.getClassrooms(); }
            } catch (error) { console.log(error); }
        },

        async getActiveTestStatus() {
            try {
                const response = await StudentDataService.activeStatus();
                if (response.data.length === 1) {
                    return response.data[0];
                }
                return 0;
            } catch (error) {
                console.log(error);
                return null;
            }
        },

        async isTestActivated() {
            try {
                const response = await StudentDataService.isTestActivated();
                if (response.data.length === 1) {
                    this.loadingNM       = false;
                    this.loadingNI       = false;
                    this.loadingNE       = false;
                    this.provaId         = response.data[0].id;
                    this.provaNome       = response.data[0].nome;
                    this.nAlts           = response.data[0].perguntas[0].answers.length;
                    this.nQuestoes       = response.data[0].perguntas.length;
                    this.questoes        = response.data[0].perguntas;
                    this.statusProva     = response.data[0].status;
                    this.statusNomeProva = response.data[0].get_status_display;
                    this.notaMaxima      = response.data[0].nota_maxima;
                    this.notaIndividual  = response.data[0].nota_individual;
                    this.notaEquipe      = response.data[0].nota_equipe;
                    this.savedIndividualAnswers = (response.data[0].respostas_salvas || []).map((answerGroup) => this.extractSavedAnswerWeights(answerGroup));
                    return this.provaId;;
                }
                return 0;
            } catch (error) {
                console.log(error);
                return null;
            }
        },

        nextQuestion() {
            this.loadingButtons = true;
            // Verifique se há uma próxima pergunta disponível
            if ((this.questionIndex + 1) < this.questoes.length) {
                this.questionIndex++;
                if (this.statusProva === '4' && this.$refs.formAnswer) {
                    this.$refs.formAnswer.reset();
                }
            }
            else if ((this.questionIndex + 1) === this.questoes.length) {
                this.provaOK = true;
            }
        },

        prevQuestion() {
            this.loadingButtons = true;
            // Verifique se há uma pergunta aneterior disponível
            if ((this.questionIndex - 1) >= 0) {
                if (this.statusProva === '4' && this.$refs.formAnswer) {
                    this.$refs.formAnswer.reset();
                }
                this.questionIndex--;
            } 
        },

        generateJsonFromArray(array) {
            const jsonData = {
              answers: array.map(item => ({ answer: item.toString() }))
            };
            return [jsonData];
        },

        generateJsonFromInt(question, answer) {
            const key    = 'question' + question.toString();  // Crie a chave corretamente
            const value  = [answer.toString()];
            const result = {};
            result[key]  = value;                             // Crie o objeto com a chave e o valor
            return result;
        },

        async onSubmitAnswer() {
            this.loadingSaveAnswer = true;
            const { valid } = await this.$refs.formAnswer.validate();
            if (valid) {
                await StudentDataService.submitStudentAnswer({
                    prova: this.currentParamsPage.id,
                    usuario: store.state.userId,
                    question_index: this.currentQuestionIndex,
                    respostas: this.generateJsonFromArray(this.answers),
                }).then(response => {
                    this.savedIndividualAnswers[this.currentQuestionIndex] = [...this.answers];
                    this.nextQuestion();
                }).catch(error => {
                    this.alertType = 'error';
                    this.alertText = error.response.data.error;
                    this.sbColor   = this.alertType;
                    this.sbMessage = this.alertText;
                    this.alert     = true;
                    this.snackbar  = true;
                })
            }
            this.loadingSaveAnswer = false;
        },

        async onSubmitGroup() {
            this.loadingSaveGroup = true;
            const { valid } = await this.$refs.formGroup.validate();
            if (valid) {
                await StudentDataService.submitGroup({prova: this.currentParamsPage.id, nome: this.groupName, usuarios: JSON.parse(JSON.stringify(this.selectedStudents))}).then(response => {
                    this.dialogGroup = false;
                    this.sbColor     = 'success';
                    this.sbMessage   = 'O grupo foi criado!';
                }).catch(error => {
                    this.alertType = 'error';
                    this.alertText = error.response.data.error;
                    this.sbColor   = this.alertType;
                    this.sbMessage = this.alertText;
                    this.alert     = true;
                })
                this.snackbar = true;
                this.$refs.formGroup.reset();
            }
            this.loadingSaveGroup = false;
        },

        async onSubmitGroupAnswer() {
            this.loadingSaveGroupAnswer = true;
            const { valid } = await this.$refs.formAnswer.validate();
            if (valid) {
                this.attempt++;
                if ((this.groupAnswer + 1) !== parseInt(this.currentQuestion.altTrue) && this.attempt !== this.nAlts) {
                    this.disableRadio(this.groupAnswer);
                    this.alertType = 'error';
                    this.alertText = 'Você errou, tente de novo!';
                }
                else if ((this.groupAnswer + 1) === parseInt(this.currentQuestion.altTrue) || this.attempt === this.nAlts) {    
                    if (this.attempt === this.nAlts) { 
                        this.alertType = 'error';
                        this.alertText = 'Você acertou apenas na última tentativa! Não recebeu pontuação.';
                    }
                    else {
                        this.alertType = 'success';
                        this.alertText = 'Você acertou!';
                    }
                }
                await StudentDataService.submitGroupAnswer({prova: this.currentParamsPage.id, respostas: this.generateJsonFromInt((this.questionIndex+1),(this.groupAnswer+1))}).then(response => {
                    this.sbColor   = this.alertType;
                    this.sbMessage = this.alertText;
                    if ((this.groupAnswer + 1) === parseInt(this.currentQuestion.altTrue) || this.attempt === this.nAlts) { this.nextQuestion(); }
                }).catch(error => {
                    this.alertType = 'error';
                    this.alertText = error.response.data.error;
                    this.sbColor   = this.alertType;
                    this.sbMessage = this.alertText;
                })
                this.alert    = true;
                this.snackbar = true;
            }
            this.loadingSaveGroupAnswer = false;
        },

        rowClick(item, row) {   
            this.dialogClassPwd = true;
            this.testId         = row.item.value;
        },

    },
};
